import React from 'react';
import {Button, Grid, Typography } from '@mui/material';
import styles from 'styles/informacionDelCard';
import TituloConIcono from 'components/tituloConIcono';
import ElementoDelCard from 'components/card/ElementoDelCard';
import { Visibility } from '@mui/icons-material';
import { functions } from 'constantes/functions';

const Television = ({televisions = [], obtenerDocumentoAdjunto}) => {
  const classes = styles();

  const validarTipoTelevsion = (television, index) => {
    const {/*numeroOrdenUncosu, numeroRegistroUncosu,*/ id, numeroCertificacionUncosu, fechaVigenciaHastaUncosu, /*numeroOrdenSit, numeroRegistroSit,*/ numeroCertificacionSit, fechaVigenciaHastaSit, licOpSatelital, numeroOrdenSatel, numeroRegistroSatel, fechaVigenciaSatelital, tipoDeTelevision, idTipoDeTelevision, esArrendatario, autorizaProPolitica, fechaInicioArrenda, fechaFinArrenda} = television || {};

    const bloqueArrendamiento = (
      <>
        <TituloConIcono title={"Datos de arrendamiento"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
        <ElementoDelCard title={'Es arrendatario:'} label={ esArrendatario ? "SI" : "NO" || ""}/>
        {esArrendatario ? (
          <>
            <ElementoDelCard title={'Fecha final:'} label={functions.FormatearFecha(fechaFinArrenda || "") || ""}/>
            <ElementoDelCard title={'Tiene autorización para transmitir Pro Política:'} label={ autorizaProPolitica ? "SI" : "NO" || ""}/>
            <Grid item xs={12} md={6} mt={2}>
              <Button variant="contained" color="primary" onClick={() => obtenerDocumentoAdjunto({id: 4, nombre: "television", registroId: id}, "pdfContratoArrenda")} size="large">
                <Visibility />
                Ver contrato
              </Button>
            </Grid>
          </>
        ) : null}
      </>
    );

    switch(Number(idTipoDeTelevision)) {
      case 1: // TV POR CABLE
        return (
        <>
          <TituloConIcono title={"Datos del UNCOSU"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
          <ElementoDelCard title={'Número de certificación y registro:'} label={numeroCertificacionUncosu || ""}/>
          {/*<ElementoDelCard title={'Número de orden:'} label={numeroOrdenUncosu || ""}/>
          <ElementoDelCard title={'Número de registro:'} label={numeroRegistroUncosu || ""}/>*/}
          <ElementoDelCard title={'Fecha de vigencia hasta:'} label={functions.FormatearFecha(fechaVigenciaHastaUncosu || "") || ""}/>
          <Grid item xs={12} md={6} mt={2}>
            <Button variant="contained" color="primary" onClick={() => obtenerDocumentoAdjunto({id: 4, nombre: "television", registroId: id}, "pdfConstUncosu")} size="large">
              <Visibility />
              Ver constancia de UNCOSU
            </Button>
          </Grid>
          {bloqueArrendamiento}
        </>
      );
      case 2: //TV abierta
        return (
        <>
          <TituloConIcono title={"Datos del SIT"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
          <ElementoDelCard title={'Número de certificación y registro:'} label={numeroCertificacionSit || ""}/>
          {/*<ElementoDelCard title={'Número de orden:'} label={numeroOrdenSit || ""}/>
          <ElementoDelCard title={'Número de registro:'} label={numeroRegistroSit || ""}/>*/}
          <ElementoDelCard title={'Fecha de vigencia hasta:'} label={functions.FormatearFecha(fechaVigenciaHastaSit || "") || ""}/>
          <Grid item xs={12} md={6} mt={2}>
            <Button variant="contained" color="primary" onClick={() => obtenerDocumentoAdjunto({id: 4, nombre: "television", registroId: id}, "pdfSit")} size="large">
              <Visibility />
              Ver constancia del SIT
            </Button>
          </Grid>
          {bloqueArrendamiento}
        </>
        );
      case 3: // TV satelital
        return (
        <>
          <TituloConIcono title={"Licencia de usuario de operación de facilidades satelitales:"} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
          <ElementoDelCard title={'Licencia de facilidades satelitales:'} label={ licOpSatelital ? "SI" : "NO" || "" }/>
          {licOpSatelital ? (
            <>
              <ElementoDelCard title={'Fecha de vigencia hasta:'} label={fechaVigenciaSatelital || ""}/>
              <Grid item xs={12} md={6} mt={2}>
                <Button variant="contained" color="primary" onClick={() => obtenerDocumentoAdjunto({id: 4, nombre: "television", registroId: id}, "pdfLicenciaSatel")} size="large">
                  <Visibility />
                  Ver licencia de usuario
                </Button>
              </Grid>
            </>
          ) : null}
          {bloqueArrendamiento}
        </>
      );
      default: return <Typography>No existe Componente para mostrar</Typography>;
    }
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={2} justifyContent="flex-start" alignItems="stretch">
        {televisions.map((television, index) => (
          <Grid item xs={12} key={television?.id || index}>
            <TituloConIcono title={`Tipo de televisión: ${television?.tipoDeTelevision?.descripcion || ''}`} mostrarTiempo={false} mostrarBotones={false} showIcon={false} />
            <ElementoDelCard title={'Tipo:'} label={television?.tipoDeTelevision?.descripcion || ""}/>
            {validarTipoTelevsion(television, index)}
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

export default Television;